import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Image, StyleSheet, Text, View } from './components/base_components';
import ProgressSpinner from './components/progress_spinner';

import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  loadingScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'var(--standard-screen-bg)',
  },
  topLine: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  image: {
    width: '25rem',
    height: '5rem',
  },
  boxView: {
    alignSelf: 'stretch',
    margin: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  box: {
    flex: 1,
    padding: '3rem',
    maxWidth: '40rem',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: 'var(--standard-text)',
    fontSize: '2rem',
    fontWeight: '600',
  },
  spinner: {
    marginTop: '4rem',
  },
});

const LOGO = require('./assets/img/logo.png');

export default function LoadingScreen(props) {
  const forever = props?.forever ?? false;
  const dest = useLocation()?.state?.from ?? '/';
  const is_ready = UserStore.useIsReady();
  React.useEffect(() => {
    if (forever) {
      UserStore.verifySessionKey({ retry: true }, () => {});
    }
  }, [forever]);

  let content: any = null;
  if (is_ready && !props.noNav) {
    content = <Navigate to={dest} />;
  } else {
    content = (
      <View style={styles.loadingScreen}>
        <View style={styles.topLine}>
          <Image style={styles.image} source={LOGO} />
        </View>
        <View style={styles.boxView}>
          <View style={styles.box}>
            <Text style={styles.title}>Loading...</Text>
            <ProgressSpinner style={styles.spinner} color='#333' />
          </View>
        </View>
      </View>
    );
  }
  return content;
}
